// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const displayName = {
  display_name: 'Client',
};
